const acc = location.host === 'portalacc.tracefy.net' ? 'waypointsacc' : 'waypoints'

export default {
  address: process.env.VUE_APP_SOCKET_IO_ADDRESS || `https://${acc}.tracefy.net:3000`
}
